import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { ResponsivePNG } from 'sports-react';
import StyledComponent from '~/components/Styled/Styled';

import css from '~/components/PlayerLineupInfo/PlayerLineupInfo.scss';

const getPositionAbbreviation = player => get(player, 'position_abbreviation');
const getPlayerName = player => get(player, 'first_initial_and_last_name');

class PlayerLineupInfo extends React.PureComponent {
  render() {
    if (!this.props.player || !Object.keys(this.props.player).length) {
      return null;
    }

    const stats = this.props.stats;

    return (
      <div className={`row ${css.container}`}>
        <span className={css.playerName}>
          <span className="col-xs-1">{getPositionAbbreviation(this.props.player)}</span>
          <span className={css.playerNameTitle}>{getPlayerName(this.props.player)}</span>
          <div className={css.icons}>
            {stats.goals > 0 ? (
              <div className={css.goalIconContainer}>
                {[...Array(stats.goals)].map(() => (
                  <ResponsivePNG
                    src={`/static/images/soccer/goal.png`}
                    alt="Goal"
                    className={classNames(css.icon, css.goalIcon)}
                  />
                ))}
              </div>
            ) : null}
            {stats.has_yellow_card && !stats.has_red_card ? (
              <ResponsivePNG
                src={`/static/images/soccer/yellowCard.png`}
                alt="Yellow Card"
                className={css.icon}
              />
            ) : null}
            {!stats.has_yellow_card && stats.has_red_card ? (
              <ResponsivePNG
                src={`/static/images/soccer/redCard.png`}
                alt="Red Card"
                className={css.icon}
              />
            ) : null}
            {stats.has_yellow_card && stats.has_red_card ? (
              <ResponsivePNG
                src={`/static/images/soccer/redAndYellow.png`}
                alt="Yellow and Red Card"
                className={css.icon}
              />
            ) : null}
            {stats.substituted_at && stats.play_status === 'Starter' ? (
              <div className={css.substitutionContainer}>
                <span className={css.redArrowLeft} />
                <span className={css.substitutionTime}>{stats.substituted_at}</span>
              </div>
            ) : null}
            {stats.substituted_at && stats.play_status === 'Benched' ? (
              <div className={css.substitutionContainer}>
                <span className={css.greenArrowRight} />
                <span className={css.substitutionTime}>{stats.substituted_at}</span>
              </div>
            ) : null}
          </div>
        </span>
      </div>
    );
  }
}

PlayerLineupInfo.propTypes = {
  player: PropTypes.shape({
    first_initial_and_last_name: PropTypes.string.isRequired,
    position_abbreviation: PropTypes.string.isRequired,
    api_uri: PropTypes.string.isRequired,
  }).isRequired,
  stats: PropTypes.shape({
    play_status: PropTypes.string,
    has_yellow_card: PropTypes.bool,
    has_red_card: PropTypes.bool,
    substituted_at: PropTypes.string,
    substituted_for: PropTypes.string,
  }).isRequired,
};

PlayerLineupInfo.displayName = 'PlayerLineupInfo';

export default StyledComponent(PlayerLineupInfo, [css]);
